export default {"src":"/_next/static/media/shap1.87a44ed8.svg","height":13,"width":14};